import { connect } from 'react-redux'
import Summary from './Summary'

const mapStateToProps = (state, ownProps) => {
  const questions = state.exam.questions;
  const max = state.exam.max;
  const type = state.exam.type;
  const categories = state.exam.categories;
  const score = categories.reduce((total, category) => total + category.score, 0);
  let success = true;
  let resultText = '';

  // If max equal "m", we check if every categories score is above the average
  if (max === 'm') {
    for (const category of categories.filter(c => c.total > 0)) {
      if (category.score < category.total / 2) {
        success = false;
      }
    }
  } else if (score < (questions.length - max)) {
    success = false;
  }

  if (success) {
    if (score === questions.length) {
      resultText = 'Parfait ! Vous n\'avez fait aucune faute.';
    } else {
      resultText = 'Vous avez réussi !';
    }
  } else {
    if (max === 'm') {
      resultText = 'Désolé, vous n\'avez pas obtenu la moyenne à chacune des catégories.';
    } else {
      resultText = 'Désolé, vous avez fait plus de ' + max + ' fautes.';
    }
  }

  return {
    type: type,
    categories: categories.filter(c => c.total > 0),
    score: score,
    questions: questions,
    max: max,
    success: success,
    resultText: resultText
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Summary);
